import config from '../../config/config';
import { sessionAwareFetch } from './sessionAwareFetch';
export const aiService = {
    /**
     * Sends the full conversation history to the AI endpoint
     * @param {Array<{role: string, content: string}>} messages
     * @returns {Promise<{status: number, data?: any, error?: string}>}
     */
    async messageChatbot(messages) {
        try {
            const response = await sessionAwareFetch(
                `${config.apimUrl}/ai-api/Chatbot/Message`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Ocp-Apim-Subscription-Key': config.apimKeyArtificialIntelligenceService,
                    },
                    credentials: 'include',
                    body: JSON.stringify({ messages }),
                }
            );

            const status = response.status;
            const text = await response.text();

            let data = null;
            try {
                data = text ? JSON.parse(text) : null;
            } catch {
                // If the response isn't valid JSON, just keep the raw text
                data = text;
            }

            return { status, data };
        } catch (err) {
            // Network-level error
            return {
                status: 0,
                error: err.message || 'Network error',
            };
        }
    },

    /* Fetches service recommendations leveraging GPT if the user provides the ServiceType (the type of service) and their CustomerDemand (what they need) */
    async getAiRecommendations(ServiceType, CustomerDemand) {
        try {
            const response = await sessionAwareFetch(
                `${config.apimUrl}/ai-api/Service-Search/Query`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Ocp-Apim-Subscription-Key': config.apimKeyArtificialIntelligenceService,
                    },
                    credentials: 'include',
                    body: JSON.stringify({ ServiceType, CustomerDemand }),
                }
            );

            const status = response.status;
            const text = await response.text();

            let data = null;
            try {
                data = text ? JSON.parse(text) : null;
            } catch {
                // If the response isn't valid JSON, just keep the raw text
                data = text;
            }

            return { status, data };

        }
        catch (err) {
            // Network-level error
            return {
                status: 0,
                error: err.message || 'Network error',
            };
        }
    },

    async getRecommendationHistory(accountId) {
        try {

            const params = new URLSearchParams();
            if (accountId) {
                params.set('AccountId', accountId);
            }
            const response = await sessionAwareFetch(
                `${config.apimUrl}/ai-api/Service-Search/Recommendations?${params.toString()}`,
                {
                    method: 'GET',
                    headers: {
                        'Ocp-Apim-Subscription-Key': config.apimKeyArtificialIntelligenceService,
                    },
                    credentials: 'include',
                }
            );
            const data = await response.json();
            return data?.SearchResults ?? [];

        }
        catch (err) {
            throw err;
        }
    }
};
